import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LoyaltyCard = ({ points, tier, nextTierPoints }) => {
  const progress = (points / nextTierPoints) * 100;

  const tierColors = {
    silver: 'from-gray-400 to-gray-600',
    gold: 'from-yellow-400 to-yellow-600',
    platinum: 'from-purple-400 to-purple-600'
  };

  return (
    <div className={`bg-gradient-to-br ${tierColors?.[tier]} rounded-xl p-6 text-white shadow-lg`}>
      <div className="flex items-start justify-between mb-6">
        <div>
          <p className="text-sm opacity-90 mb-1">Loyalty Points</p>
          <p className="text-3xl md:text-4xl font-bold">{points?.toLocaleString('en-IN')}</p>
        </div>
        <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
          <Icon name="Award" size={24} />
        </div>
      </div>
      <div className="space-y-2 mb-6">
        <div className="flex items-center justify-between text-sm">
          <span className="opacity-90">Current Tier: {tier?.charAt(0)?.toUpperCase() + tier?.slice(1)}</span>
          <span className="font-semibold">{Math.round(progress)}%</span>
        </div>
        <div className="w-full h-2 bg-white/20 rounded-full overflow-hidden">
          <div
            className="h-full bg-white rounded-full transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>
        <p className="text-xs opacity-75">
          {nextTierPoints - points} points to next tier
        </p>
      </div>
      <Button
        variant="outline"
        size="sm"
        iconName="Gift"
        iconPosition="left"
        className="w-full bg-white/10 border-white/30 text-white hover:bg-white/20"
      >
        Redeem Rewards
      </Button>
    </div>
  );
};

export default LoyaltyCard;